import React, { useEffect, useState } from 'react';
import QRCode from 'qrcode';

export const VMK_AGREEMENT_QR_URL = 'https://www.vmkkozijnen.nl';

const VmkAgreementQrCode = ({ className = '' }) => {
  const [src, setSrc] = useState('');

  useEffect(() => {
    let cancelled = false;

    QRCode.toDataURL(VMK_AGREEMENT_QR_URL, {
      width: 132,
      margin: 1,
      errorCorrectionLevel: 'M',
      color: {
        dark: '#111827',
        light: '#ffffff',
      },
    })
      .then((dataUrl) => {
        if (!cancelled) setSrc(dataUrl);
      })
      .catch(() => {
        if (!cancelled) setSrc('');
      });

    return () => {
      cancelled = true;
    };
  }, []);

  const qrImage = src ? (
    <img src={src} alt="" className={`vmk-agreement-qr-image ${className}`.trim()} />
  ) : (
    <div className={`vmk-agreement-qr-placeholder ${className}`.trim()} aria-hidden />
  );

  return (
    <a
      className="vmk-agreement-qr-link"
      href={VMK_AGREEMENT_QR_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={VMK_AGREEMENT_QR_URL}
    >
      {qrImage}
    </a>
  );
};

export default VmkAgreementQrCode;
